var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav',{staticClass:"result-tabs",attrs:{"tabs":""}},_vm._l((_vm.tabs),function(tab,index){return _c('b-nav-item',{key:tab,attrs:{"active":_vm.value === index},on:{"click":function($event){return _vm.$emit('input', index)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }